import { Package } from 'lucide-react';
import type { CartItem as OrderItem } from '../types';
import { formatCurrency } from '~/utils';

interface OrderItemProps {
  id: string;
  name: string;
  dimensions: string;
  quantity: number;
  unit: string;
  price: number;
  total: number;
}

export function OrderItem({
  name,
  dimensions,
  quantity,
  unit,
  price,
  total,
}: Readonly<OrderItemProps>) {
  return (
    <div className="flex gap-4 pb-4 border-b border-neut-100 last:border-0 last:pb-0">
      <div className="w-16 h-16 bg-gradient-to-br from-amber-50 to-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
        <div className="text-xl">🌲</div>
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm text-neut-prim font-medium mb-1 truncate">
          {name}
        </h4>
        <p className="text-xs text-neut-sec mb-1">{dimensions}</p>
        <p className="text-xs text-neut-500">
          {quantity} {unit} × {formatCurrency(price)}/{unit}
        </p>
      </div>
      <div className="text-right flex-shrink-0">
        <p className="text-sm text-neut-prim font-semibold">
          {formatCurrency(total)}
        </p>
      </div>
    </div>
  );
}

export function OrderItems({
  items,
  title,
}: Readonly<{
  items: OrderItem[];
  title: string;
}>) {
  return (
    <div className="bg-neut-bg-alt rounded-lg border border-neut-border p-6 shadow-neut-100">
      <div className="flex items-center gap-2 mb-4">
        <Package className="w-5 h-5 text-prim" />
        <h2 className="text-neut-prim font-semibold">{title}</h2>
      </div>
      <div className="space-y-4">
        {items?.map((item) => (
          <OrderItem
            key={item.platformProductsLengths.id}
            id={item.platformProductsLengths.id}
            name={item.platformProductsLengths.platformProduct.name}
            dimensions={item.platformProductsLengths.platformProduct.name}
            quantity={item.quantity.value}
            unit={item.quantity.unit}
            price={item.price}
            total={item.quantity.value * item.price}
          />
        ))}
      </div>
    </div>
  );
}
